<template>
  <div
      :class="[toggleAudioPanel ? 'icon-tilt' : '']"
      class="widget-inner py-8 px-16 expand-icon"
      @click.stop="toggleAudioSection">
    <panel-heading
        :is-open="toggleAudioPanel"
        :right-icon="product && !product.audioDetails ? '' : 'chevron'"
        title="Audio"
        left-icon="audio"
        section="Audio"/>
    <div
        v-if="toggleAudioPanel"
        class="accordion-collapse">
      <div class="accordion-body p-0">
        <div class="bm-collapse Images color-selector shape-selector shapes mt-32 mb-8">
          <audio-options :product="product"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PanelHeading from '@/components/PanelHeading/PanelHeading';
import Icon from '@/components/Icon/Icon.vue';
import UtiltyButtonsPanel from '@/components/UtiltyButtonsPanel/UtiltyButtonsPanel';
import EventBus from '@/EventBus';
import ApplicationEventTypes from '@/mixins/ApplicationEventTypes';
import AudioOptions from '@/components/Audio/AudioOptions';


export default {
  name:       'AudioComponent',
  components: {
    'panel-heading':         PanelHeading,
    Icon,
    'utility-buttons-panel': UtiltyButtonsPanel,
    'audio-options':         AudioOptions,
  },
  props: {
    product: Object,
  },
  data() {
    return {
      toggleAudioPanel: false,
      trimToggleBtn:    false,
    };
  },
  watch: {
    '$store.state.activeProduct.isAudioTrimOn': {
      handler(value) {
        this.trimToggleBtn = value;
      },
    },
  },
  mounted() {
    EventBus.$on('toggleAudioLeftSectionAccordion', this.toggleAudioLeftSectionAccordion);
  },
  destroyed() {
    EventBus.$off('toggleAudioLeftSectionAccordion', this.toggleAudioLeftSectionAccordion);
  },
  methods: {
    toggleAudioLeftSectionAccordion(value) {
      this.toggleAudioPanel = value;
      this.$store.commit('activeProduct/UpdateIsAudioTrimOn', value);
    },
    toggleHandler() {
      this.$store.commit('activeProduct/UpdateIsAudioTrimOn', this.trimToggleBtn);
      this.trimToggleBtn = this.$store.getters['activeProduct/getIsAudioTrimOn'];
      if (this.trimToggleBtn) {
        EventBus.$emit(ApplicationEventTypes.AnimationEvent.STOP_OBJECT_ANIMATION);
      }
    },
    toggleAudioSection() {
      EventBus.$emit(ApplicationEventTypes.AnimationEvent.STOP_OBJECT_ANIMATION);
      if (this.product && this.product.audioDetails) {
        this.toggleAudioPanel = !this.toggleAudioPanel;
        EventBus.$emit('selectAudioLayerFromLeftSection', this.toggleAudioPanel);
        this.$store.commit('activeProduct/UpdateIsAudioTrimOn', this.toggleAudioPanel);
      }
    },
  },
};
</script>

<style scoped lang="scss">
.audio-icon {
  display: flex;
  height: 50px;
}

.audio-name {
  color: #000;
  font-family: Open Sans;
  font-size: 13px;
  font-style: normal;
  font-weight: 700;
  line-height: 20px;
  width: 168px;
  height: 23px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.audio-details {
  display: flex;
  flex-direction: column;
  margin-left: 10px;
}

.audio-animation {
  color: #000;
  font-family: Open Sans;
  font-size: 13px;
  font-style: normal;
  font-weight: 700;
  line-height: 20px;
}

.utility-buttons-wrapper {
  .switch {
    height: 8px;
    width: 12px;

    input {
      opacity: 0;
    }
  }

  .slider {
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    -webkit-transition: .4s;
    transition: .4s;

    &:before {
      position: absolute;
      content: "";
      height: 4px;
      width: 4px;
      left: 1px;
      top: 1px;
      background-color: white;
      border: 1px solid $grey80;
      -webkit-transition: .4s;
      transition: .4s;
    }
  }

  input {
    &:checked {
      + .slider {
        border: 1px solid $blue50 !important;

        &:before {
          -webkit-transform: translateX(3px);
          -ms-transform: translateX(3px);
          transform: translateX(3px);
          border: 1px solid $blue50 !important;
        }
      }

      ~ .toggle-label {
        color: green;
      }
    }

    &:focus {
      + .slider {
        box-shadow: 0 0 1px #2196F3;
      }
    }
  }

  .slider {
    &.round {
      &:before {
        border-radius: 50%;
      }

      border-radius: 34px;
    }
  }
}
</style>
